export const orientationStyles = {
    horizontal: {alignItems: 'center'},
    vertical: {
        flexDirection: 'column',
    },
}

export const preventNegativeAndFloats = (event) => {
    if (event.code === 'Minus' || event.code === 'Period') {
        event.preventDefault()
    }
}

export const findKey = (obj, value) =>
    Object.keys(obj).find((key) => obj[key] === value)
